import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { getFiltroPadraoRelatorioInventario } from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import { baixarArquivoBase64 } from '../../utils/download';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import Filtros from '../../components/Filtros/Filtros';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import TotalizadorRelatorio from '../../components/TotalizadorRelatorio/TotalizadorRelatorio';
import Tabela from '../../components/Tabela/Tabela';
import InputData from '../../components/Inputs/InputData/InputData';

function RelInventario() {
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [relInventario, setRelInventario] = useState([]);
  const [totalCusto, setTotalCusto] = useState(0);
  const [totalVenda, setTotalVenda] = useState(0);

  async function GetRelInventario(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/InventarioReport/GetList', payload);
    let data = res.data;
    if (res.status === 200) {
      setRelInventario(data.Produtos);
      if (data.Produtos && Object.keys(data.Produtos).length > 0) {
        let custo = 0;
        let venda = 0;

        data.Produtos.map(rel => (custo += rel.TotalPrecoCusto));

        data.Produtos.map(rel => (venda += rel.TotalPrecoVenda));

        setTotalCusto(custo);
        setTotalVenda(venda);
      } else {
        setTotalCusto(0);
        setTotalVenda(0);
      }
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    if (search.get('filter')) {
      setShowFilters(search.get('filter') === 'true');
      GetRelInventario(getFiltroPadraoRelatorioInventario());
    }
  }, [search]);

  useEffect(() => {
    GetRelInventario(getFiltroPadraoRelatorioInventario());
  }, []);

  const getPDF = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relInventario, null, 2),
    };
    baixarArquivoBase64('/InventarioReport/GetPDF', payload);
  };

  const getExcel = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relInventario, null, 2),
    };
    baixarArquivoBase64('/InventarioReport/GetExcel', payload);
  };

  return (
    <Pagina loading={loading}>
      <FormikPadrao
        initialValues={getFiltroPadraoRelatorioInventario()}
        onSubmit={async values => {
          await GetRelInventario(values);
        }}
      >
        <BarraBotoes
          maxWindowSize={1030}
          botoes={[
            {
              children: 'Exportar Planilha',
              onClick: getExcel,
              variant: 'verde',
            },
            {
              children: 'Exportar PDF',
              onClick: getPDF,
              variant: 'rosa',
            },
          ]}
          search={{
            placeholder: 'Procurar por pedidos',
            onChange: e => setSearchBar(e.target.value),
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />
        <FilterMenu showFilters={showFilters} setShowFilters={setShowFilters} />
        <TotalizadorRelatorio
          items={[
            {
              Titulo: 'VALOR TOTAL DE CUSTO',
              Valor: totalCusto,
              type: 'money',
            },
            {
              Titulo: 'VALOR TOTAL DE VENDA',
              Valor: totalVenda,
              type: 'money',
            },
          ]}
        />
        <Tabela
          titulo={'RELATÓRIO DE INVENTÁRIO'}
          setFunction={setRelInventario}
          data={relInventario}
          columns={[
            {
              placeholder: 'CÓDIGO',
              name: 'Codigo',
              type: 'text',
            },
            {
              placeholder: 'PRODUTO',
              name: 'Descricao',
              type: 'text',
            },
            {
              placeholder: 'SALDO',
              name: 'Saldo',
              type: 'text',
            },
            {
              placeholder: 'PREÇO CUSTO',
              name: 'PrecoCusto',
              type: 'money',
            },
            {
              placeholder: 'TOTAL PREÇO CUSTO',
              name: 'TotalPrecoCusto',
              type: 'money',
            },
            {
              placeholder: 'PREÇO VENDA',
              name: 'PrecoVenda',
              type: 'money',
            },
            {
              placeholder: 'TOTAL PREÇO VENDA',
              name: 'TotalPrecoVenda',
              type: 'money',
            },
            {
              placeholder: 'ESTOQUE',
              name: 'Estoque',
              type: 'text',
            },
            {
              placeholder: 'EMPRESA',
              name: 'Empresa',
              type: 'text',
            },
          ]}
          searchBar={searchBar}
        />
      </FormikPadrao>
    </Pagina>
  );
}

function FilterMenu({ showFilters, setShowFilters }) {
  return (
    <Filtros showFilters={showFilters} setShowFilters={setShowFilters}>
      <InputFiltro
        titulo="EMPRESA"
        id="Empresa"
        name="Empresa"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Empresa'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="DEPÓSITO"
        id="Estoque"
        name="Estoque"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Deposito'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PRODUTO"
        id="Produto"
        name="Produto"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Produtos'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data"
        id="Data"
        name="Data"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
    </Filtros>
  );
}

export default RelInventario;
